import React from 'react';
import CommanderCardsGrid, { CommanderDamage } from 'components/commander/CommanderCardsGrid';
import BaseModal from 'components/modal/BaseModal';
import styles from './CommanderModal.css';

interface Props {
    visible: boolean;
    commanderDamage: CommanderDamage[];
    onIncrease: (opponentId: string, amount: number) => void;
    onDecrease: (opponentId: string, amount: number) => void;
    onIncreaseDeaths?: () => void;
    onDecreaseDeaths?: () => void;
    onClose: () => void;
    playerRotation: number;
    commanderDeaths?: number;
}

const CommanderModal = ({
    visible,
    commanderDamage,
    onIncrease,
    onDecrease,
    onIncreaseDeaths,
    onDecreaseDeaths,
    onClose,
    playerRotation,
    commanderDeaths = 0,
}: Props) => {
    return (
        <BaseModal
            visible={visible}
            onClose={onClose}
            rotation={playerRotation}
            contentStyle={{ padding: 20 }}
        >
            <div className={styles.gridContainer}>
                <CommanderCardsGrid
                    commanderDamage={commanderDamage}
                    onIncrease={onIncrease}
                    onDecrease={onDecrease}
                    onIncreaseDeaths={onIncreaseDeaths}
                    onDecreaseDeaths={onDecreaseDeaths}
                    isBig={true}
                    playerRotation={playerRotation}
                    commanderDeaths={commanderDeaths}
                />
            </div>
        </BaseModal>
    );
};

export default CommanderModal;
